import React, { useEffect, useState, useMemo, lazy, Suspense } from "react";
import { Message, Tooltip } from "@cloud/atom-ui";
import "./style.m.less";
import homeIcon from './assets/home.svg';
import leftIcon from './assets/left.svg';
import { bindEAMAP, appBasicInfo, getcurrentrole } from './thunk';
import history from "../../utils/history";
import { queryString } from '../../utils/common';
import { useDispatch } from 'redux-react-hook';
import { ROLE_TYPE } from '../../utils/constant';
import * as actions from "@src/actions/index";
import i18n from '@src/i18n';
import useMappedState from '@src/utils/useMappedState';
import { showMessage } from "../../utils/common";

const BindModal = lazy(() => import('../BindModal'))

const BindHeader = () => {
  const { appBaseInfo, roleType } = useMappedState('root');
  const [isBindVisible, setIsBindVisible] = useState(false);
  const appId = queryString("appId");
  const dispatch = useDispatch();

  // 获取应用基本的信息
  const getAppInfo = () => {
    appBasicInfo(appId).then(res => {
      const { code, data = {} } = res;
      if (code === 200) {
        dispatch(actions.appBaseInfo(data));
      }
    });
  };

  // 获取登用户角色
  const getUserRole = () => {
    getcurrentrole(appId).then(res => {
      const { code, data = ROLE_TYPE.noPermission } = res;
      if (code === 200) {
        dispatch(actions.setRoleType(data));
      } else {
        history.push('/appList');
        Message.error(i18n.t('baseInfo:getRoleFailed'));
      }
    });
  };

  // 绑定EAMAP
  const onBindEAMAP = () => {
    setIsBindVisible(true);
  };

  const handleBind = (value) => {
    value.appId = appId;
    bindEAMAP(value).then(res => {
      if (res?.code === 200) {
        Message.success(i18n.t('baseInfo:bindSuccess'));
        setIsBindVisible(false);
        getAppInfo();
      } else {
        showMessage(res?.code, res?.message)
      }
    })
  };

  // 应用列表页
  const goToHome = () => {
    dispatch(actions.appBaseInfo(null));
    history.push('/appList');
  };

  const renderBindName = useMemo(() => {
    let name = '';
    let code = '';
    appBaseInfo?.properties?.forEach(item => {
      if (item?.propertyName === 'eamap_app_name') {
        name = item?.propertyValue;
      } else if (item?.propertyName === 'eamap_app_code') {
        code = item?.propertyValue;
      }
    });
    return `${i18n.t('baseInfo:appModules')}/${name} ${code}`;
  }, [appBaseInfo]);

  const renderAppInfo = useMemo(() => {
    if (!appBaseInfo || Object.keys(appBaseInfo).length === 0) {
      return null;
    }
    const { appNameCn, appType } = appBaseInfo;
    // 只有owner才展示绑定模块
    const isShowBind = roleType === ROLE_TYPE.owner;

    if (isShowBind && !appType) {
      return (
        <div className="bindInfo">
          <Tooltip title={appNameCn}>
            <span className="appName">{appNameCn}</span>
          </Tooltip>
          <span>
            <span>{i18n.t('baseInfo:notBind')}：</span>
            <span className="bindButton" onClick={onBindEAMAP}>
              {i18n.t('baseInfo:bindNow')}
              <img src={leftIcon} />
            </span>
          </span>
        </div>
      )
    }
    return (
      <div className={appType ? "bindInfo" : ""}>
        <Tooltip title={appNameCn}>
          <span className="appName">{appNameCn}</span>
        </Tooltip>
        {appType ? (
          <span>
            <span>{i18n.t('baseInfo:bind')}：</span>
            <span className="bindName">{renderBindName}</span>
          </span>
        ) : <span className="appType">{i18n.t('baseInfo:personerApp')}</span>}
      </div>
    )
  }, [appBaseInfo]);

  useEffect(() => {
    getUserRole();
    getAppInfo();
  }, []);

  return (
    <div className="infoHeader">
      <img className="infoHomeIcon" src={homeIcon} onClick={goToHome} />
      <div className="infoLine"></div>
      {renderAppInfo}
      <Suspense fallback={<></>}>
        <BindModal
          isBindVisible={isBindVisible}
          setIsBindVisible={setIsBindVisible}
          handleBind={handleBind}
        />
      </Suspense>
    </div>
  )
};

export default BindHeader;